import Vue from 'vue';
import VueAutosize from 'vue-autosize';

Vue.use(VueAutosize);

export default VueAutosize;



// WEBPACK FOOTER //
// ./node_modules/@triotech/vue-core/src/lib/helper/autosize.js